import React, { useEffect, useRef, useState } from 'react';
import { useTheme } from 'styled-components';

import DisplayLogo from '@savgroup-front-common/core/atoms/DisplayLogo/DisplayLogo';
import { getCustomComponentProperty } from '@savgroup-front-common/core/helpers';
import { LanguageChooser } from '@savgroup-front-common/core/molecules/LanguageChooser';
import { useGetSellerAcceptedLanguages } from '@savgroup-front-common/core/molecules/LanguageChooser/hooks/useGetSellerAcceptedLanguages';
import {
  LOGO_POSITION,
  SUPPORTED_COMPONENTS,
  SUPPORTED_PROPERTIES,
} from '@savgroup-front-common/types';

import { AuthConfiguration } from '../../../../../configuration';
import useLogo from '../../hooks/useLogo';

import {
  $EmptyDiv,
  $HeaderContainer,
  $MenuContainer,
  $RightSide,
} from './Header.styles';

interface HeaderTestProps {
  sellerId: string;
}

const Header: React.FC<HeaderTestProps> = ({ sellerId }) => {
  const [rightSideWidth, setRightSideWidth] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const { acceptedLanguagesBySeller } = useGetSellerAcceptedLanguages({
    sellerId,
  });
  const theme = useTheme();

  const position = getCustomComponentProperty({
    theme,
    componentName: SUPPORTED_COMPONENTS.LOGO,
    property: SUPPORTED_PROPERTIES.POSITION,
    fallback: LOGO_POSITION.LEFT,
  }) as LOGO_POSITION;

  const isLanguageChooseDisplayed = !!acceptedLanguagesBySeller?.length;

  useEffect(() => {
    if (ref.current) {
      setRightSideWidth(ref.current.offsetWidth);
    }
  }, [ref.current?.offsetWidth]);

  const { sellerUrl } = useLogo({ sellerId });

  return (
    <$HeaderContainer componentThemeName={SUPPORTED_COMPONENTS.APP_HEADER}>
      <$MenuContainer $position={position}>
        {position === LOGO_POSITION.CENTER && (
          <$EmptyDiv $width={isLanguageChooseDisplayed ? rightSideWidth : 0} />
        )}

        <DisplayLogo
          sellerId={sellerId}
          clientId={AuthConfiguration.clientId}
          href={sellerUrl.href}
          isExternal={sellerUrl.isExternal}
        />
        <$RightSide ref={ref}>
          <LanguageChooser
            acceptedLanguagesBySeller={acceptedLanguagesBySeller}
          />
        </$RightSide>
      </$MenuContainer>
    </$HeaderContainer>
  );
};

export default Header;
